import React from 'react';
import styled from 'styled-components';
import { Transition } from 'react-transition-group';
import { CircularProgress } from "../CircularProgress";
import { reflow } from "../../utils/reflow";
var FADE_IN_DURATION = 400;
var FADE_OUT_DURATION = 250;
/**
 * Deferred Spinner
 */

export var Spinner = React.forwardRef(function Spinner(_ref, forwardedRef) {
  var _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? true : _ref$isLoading,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 600 : _ref$delay,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$centered = _ref.centered,
      centered = _ref$centered === void 0 ? false : _ref$centered;
  return /*#__PURE__*/React.createElement(Transition, {
    in: isLoading,
    appear: true,
    mountOnEnter: true,
    unmountOnExit: true,
    timeout: {
      enter: FADE_IN_DURATION + delay,
      exit: FADE_OUT_DURATION
    },
    onEnter: function onEnter(el) {
      return reflow(el);
    }
  }, function (state) {
    return /*#__PURE__*/React.createElement(FadeContainer, {
      $delay: delay,
      $centered: centered,
      ref: forwardedRef,
      "data-state": state
    }, /*#__PURE__*/React.createElement(CircularProgress, {
      size: getSize(size),
      background: false,
      color: "grey70"
    }));
  });
});

function getSize(size) {
  switch (size) {
    case 'medium':
      return 32;

    case 'small':
      return 24;

    case 'x-small':
      return 16;

    default:
      return 32;
  }
}

var FadeContainer = styled.div.withConfig({
  displayName: "Spinner__FadeContainer",
  componentId: "vapor__sc-1qxyaam-0"
})(["transition:opacity ", "ms linear 0s;pointer-events:none;opacity:0;&[data-state='entering'],&[data-state='entered']{opacity:1;transition-delay:", "ms;transition-duration:", "ms;}&[data-state='exiting']{opacity:0;}", ""], FADE_OUT_DURATION, function (p) {
  return p.$delay;
}, FADE_IN_DURATION, function (p) {
  return p.$centered && "\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  ";
});